/** Registers the ScrollContainer parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseScrollContainer } from './parser';
const scrollContainerRegistration = {
    typeName: 'ScrollContainer',
    parser: parseScrollContainer,
};
nodeRegistry.register(scrollContainerRegistration);
export * from './parser';
//# sourceMappingURL=index.js.map